module.exports = __webpack_public_path__ + "static/media/flower-tulip.60d0152a.svg";